var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "High Function Sports Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('sub-product', {
    attrs: {
      "tit": "High Function Sports Line",
      "file": "sports"
    }
  }, [_vm._v(" 방습성/발수성, 쿨링/히팅 기능으로 소비자의 건강한 삶을 도와줍니다. 기능성 실과 니팅 구조로 다양한 기능성을 구체화 시킵니다. 소비자의 삶을 풍요롭게 하는 다양한 아이템을 만나보세요. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }